import { ApiPostRequest } from 'src/app/model/api/api-request/api-post-request';

export class UpsaleTicketReservationRequest extends ApiPostRequest
{
    public constructor(playerId: number, ticketNumber: number, ticketLetter: string, webapiBasepath:string)
    {
        super(
            'upsale/ticketreservation',
            null,
            null,
            {
                'PlayerId': playerId,
                'TicketNumber': ticketNumber,
                'TicketLetter': ticketLetter
            },
            webapiBasepath
        );
    }
}
